import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-import",
  "use": "icon-import-usage",
  "viewBox": "0 0 1000 1000",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1000 1000\" id=\"icon-import\">\r\n<metadata> Svg Vector Icons : http://www.onlinewebfonts.com/icon </metadata>\r\n<g><path d=\"M990,944.6H10V500h980V944.6z M901.1,500H98.9v355.7h802.1V500z\" /><path d=\"M454.6,55.4h88.9v622.5h-88.9V55.4z\" /><path d=\"M10,144.3L10,144.3L10,144.3L10,144.3L10,144.3L10,144.3z\" /><path d=\"M365.7,233.2L543.6,55.4h-88.9L276.8,233.2H365.7z\" /><path d=\"M632.5,233.2L454.6,55.4h88.9l177.9,177.9H632.5z\" /></g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/import.svg
// module id = XteN
// module chunks = 11